import { render, staticRenderFns } from "./BaseKnowledgeForm.vue?vue&type=template&id=368069d0&"
import script from "./BaseKnowledgeForm.vue?vue&type=script&lang=js&"
export * from "./BaseKnowledgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports